import { render, staticRenderFns } from "./submited.vue?vue&type=template&id=3fb9a5c3&scoped=true"
import script from "./submited.vue?vue&type=script&lang=js"
export * from "./submited.vue?vue&type=script&lang=js"
import style0 from "./submited.vue?vue&type=style&index=0&id=3fb9a5c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9a5c3",
  null
  
)

export default component.exports